import React, {
  FunctionComponent,
  useEffect,
  useState,
  useRef,
  useCallback,
} from 'react';
import styles from './FilterModal.module.css';
import { AiOutlineArrowUp } from 'react-icons/ai';
import { AiOutlineArrowDown } from 'react-icons/ai';
import { AiOutlineSearch, AiOutlineClose } from 'react-icons/ai';
import { Checkbox } from '@material-ui/core';
import { connect, useDispatch } from 'react-redux';
import classNames from 'classnames';
import InfiniteScroll from 'react-infinite-scroll-component';
import { dateFieldList } from '../../../Values/tables';
import moment from 'moment';
import {
  setClearFilter,
  setFilter,
  setUserFilter,
  setTaskFilter,
  setCallLogFilter,
  setCallLogDrillDownFilter,
  setCallLogDrillDownFilterSort,
  setContactDrillDownFilter,
  setTaskFilterSort,
  setTaskDrillDownFilter,
  setContactDrillDownFilterSort,
  setTaskDrillDownFilterSort,
  setCallLogFilterSort,
  setUserFilterSort,
  setFilterSort,
  setReenquiredFilter,
  setLeadDistributionFilter,
  setLeadDistributionSortFilter,
  setAPITokensFilter,
  setAPITokensSortFilter,
  setProjectsFilter,
  setProjectsSortFilter,
  setAPIDataFilter,
  setAPIDataSortFilter,
  setDeleteLogsSortFilter,
  setDeleteLogsFilter
} from '../../../Redux/actions';
import {themeColors} from '../../theme';
import { formatLeadBudget } from '../../../Services/apiData';

type props = {
  expand: boolean;
  column: any;
  filterObject: { [key: string]: string[] };
  hide: () => void;
  filterId: string;
  globalClearFilter: boolean;
  filter: any;
  theme:any;
  panel?:any
  DrillDownpanel?:any;
};

const ApiFilterModal: FunctionComponent<props> = ({
  column,
  filterObject,
  expand,
  hide,
  filterId,
  globalClearFilter,
  filter,
  theme,
  panel,
  DrillDownpanel
}) => {
  const noFilter = ['customer_name', 'contact_no', 'email', 'alternate_no'];
  const filterRef = useRef(null);
  const [filterRow, setFilterRow] = useState<any[]>([]);
  const [dateArray, setDateArray] = useState<Date[]>([]);
  const [sort, setSort] = useState(0);
  const [searchedItem, setsearchedItem] = useState('');
  const [filterItems, setFilterItems] = useState<string[]>([]);
  const dispatcher = useDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  function option(a: { label: any } | string, b: { label: any } | string): number {
    if (typeof a === 'string' && typeof b === 'string') {
      // Handle the case where both a and b are strings
      if (a > b) return 1;
      if (a < b) return -1;
      return 0;
      
      return 0;
    } else if (typeof a === 'object' && typeof b === 'object') {
      // Handle the case where both a and b are objects with a 'label' property
      if (a.label > b.label) return 1;
      if (a.label < b.label) return -1;
    
      return 0;
    } else {
      return 0; 
    }
  }
  
  useEffect(() => {
    if (expand && inputRef.current) {
      inputRef.current.focus();
    }
  }, [expand]);
  const clearFilter = () => {
    setFilterRow([]);
    setDateArray([]);
    localStorage.setItem(filterId, JSON.stringify([]));
    localStorage.setItem(filterId + 'sort', '0');
    if(DrillDownpanel === "call logs drilldown"){
      dispatcher(setCallLogDrillDownFilterSort({}));
    }
    else if(DrillDownpanel === "contacts drilldown"){
      dispatcher(setContactDrillDownFilterSort({}));
    }
    else if(DrillDownpanel === "tasks drilldown"){
      dispatcher(setTaskDrillDownFilterSort({}));
    }
    else if(panel === "User" || panel ==="contacts"){
      dispatcher(setUserFilterSort({}));
    }
    else if(panel==="DeletedLogs"){
      dispatcher(setDeleteLogsSortFilter({}));
    }
    else if(panel === "Task"){
      dispatcher(setTaskFilterSort({}));
    }
    else if(panel === "CallLogs"){
      dispatcher(setCallLogFilterSort({}));
    }
    // else if(panel === "Reenquired"){
    //   dispatcher(setReenquiredFilterSort({}));
    // }
    else if (panel ==="API"){
      dispatcher(setAPITokensSortFilter({}));
    }
    else if (panel ==="API Leads"){
      dispatcher(setAPIDataSortFilter({}));
    }
    else if (panel ==="projects"){
      dispatcher(setProjectsSortFilter({}));
    }
    else if (panel ==="LeadDistributor"){
      dispatcher(setLeadDistributionSortFilter({}));
    }
    else{
      dispatcher(setFilterSort({}));
    }
    // ----------------------------------------------------------------
    if(DrillDownpanel === "call logs drilldown"){
      dispatcher(setCallLogDrillDownFilter({ [filter]: [] }));
    }
    else if(DrillDownpanel === "contacts drilldown"){
      dispatcher(setContactDrillDownFilter({ [filter]: [] }));
    }
    else if(DrillDownpanel === "tasks drilldown"){
      dispatcher(setTaskDrillDownFilter({ [filter]: [] }));
    }
    else if(panel === "Reenquired"){
      dispatcher(setReenquiredFilter({ [filter]: [] }));
    }
    else if(panel === "User" || panel ==="contacts" ){
      dispatcher(setUserFilter({ [filter]: [] }));
    }
    else if( panel==="DeletedLogs"){
      dispatcher(setDeleteLogsFilter({ [filter]: [] }));
    }
    else if(panel === "Task"){
      dispatcher(setTaskFilter({ [filter]: [] }));
    }
    else if(panel === "CallLogs"){
      dispatcher(setCallLogFilter({ [filter]: [] }));
    }
    else if (panel ==="API"){
      dispatcher(setAPITokensFilter({[filter]:[]}))
    }
    else if (panel ==="projects"){
      dispatcher(setProjectsFilter({[filter]:[]}))
    }
    else if (panel ==="API Leads"){
      dispatcher(setAPIDataFilter({[filter]:[]}))
    }
    else if (panel ==="LeadDistributor"){
      dispatcher(setLeadDistributionFilter({[filter]:[]}))
    }
    else{
      dispatcher(setFilter({ [filter]: [] }));
    }

    hide();
  };

  const close = () => {
    hide();
    setCurrentLimit(5);
  };

  useEffect(() => {
    if (globalClearFilter === true) {
      clearFilter();
      dispatcher(setClearFilter(false));
    }
  }, [globalClearFilter]);

  useEffect(() => {
    const savedFilters = localStorage.getItem(filterId);
    if (savedFilters) {
      if(DrillDownpanel === "call logs drilldown"){
        dispatcher(setCallLogDrillDownFilter({ [filter]: JSON.parse(savedFilters) }));
      }
      else if(DrillDownpanel === "contacts drilldown"){
        dispatcher(setContactDrillDownFilter({ [filter]: JSON.parse(savedFilters) }));
      }
      else if(DrillDownpanel === "tasks drilldown"){
        dispatcher(setTaskDrillDownFilter({ [filter]: JSON.parse(savedFilters) }));
      }
      else if(panel === "Reenquired"){
        dispatcher(setReenquiredFilter({ [filter]: JSON.parse(savedFilters) }));
      }
      else if(panel === "User" || panel ==="contacts" ){
        dispatcher(setUserFilter({ [filter]: JSON.parse(savedFilters) }));
      }
      else if(panel==="DeletedLogs"){
        dispatcher(setDeleteLogsFilter({ [filter]: JSON.parse(savedFilters) }));
      }
      else if(panel === "Task"){
        dispatcher(setTaskFilter({ [filter]: JSON.parse(savedFilters) }));
      }
      else if(panel === "CallLogs"){
        dispatcher(setCallLogFilter({ [filter]: JSON.parse(savedFilters) }));
      }
      else if (panel ==="API"){
        dispatcher(setAPITokensFilter({[filter]:JSON.parse(savedFilters)}))
      }
      else if (panel ==="projects"){
        dispatcher(setProjectsFilter({[filter]:JSON.parse(savedFilters)}))
      }
      else if (panel ==="API Leads"){
        dispatcher(setAPIDataFilter({[filter]:JSON.parse(savedFilters)}))
      }
      else if (panel ==="LeadDistributor"){
        dispatcher(setLeadDistributionFilter({[filter]:JSON.parse(savedFilters)}))
      }
      else{
        dispatcher(setFilter({ [filter]: JSON.parse(savedFilters) }));
      }

      if (dateFieldList.includes(column.Header)) {
        let dates = JSON.parse(savedFilters);
        if (dates?.length === 2) {
          let newdates = [moment(dates[0]).toDate(), moment(dates[1]).toDate()];

          setDateArray(newdates);
          setFilterRow(newdates);
        }
      } else {
        setFilterRow(JSON.parse(savedFilters));
      }
    }
    const savedSort = localStorage.getItem(filterId + 'sort');

    if (savedSort) {
      setTimeout(() => {
        if (savedSort === '1') {
          if(DrillDownpanel === "call logs drilldown"){
            dispatcher(setCallLogDrillDownFilterSort({ [filter]: 1 }));
          }
          else if(DrillDownpanel === "contacts drilldown"){
            dispatcher(setContactDrillDownFilterSort({ [filter]: 1 }));
          }
          else if(DrillDownpanel === "tasks drilldown"){
            dispatcher(setTaskDrillDownFilterSort({ [filter]: 1 }));
          }
          else if(panel === "User" || panel ==="contacts" ){
            dispatcher(setUserFilterSort({ [filter]: 1 }));
          }
          else if( panel==="DeletedLogs"){
            dispatcher(setDeleteLogsSortFilter({ [filter]: 1 }));
          }
          else if(panel === "Task"){
            dispatcher(setTaskFilterSort({ [filter]: 1 }));
          }
          else if(panel === "CallLogs"){
            dispatcher(setCallLogFilterSort({ [filter]: 1 }));
          }
          // else if(panel === "Reenquired"){
          //   dispatcher(setReenquiredFilterSort({ [filter]: 1 }));
          // }
          else if (panel ==="API"){
            dispatcher(setAPITokensSortFilter({[filter]: 1}));
          }
          else if (panel ==="API Leads"){
            dispatcher(setAPIDataSortFilter({[filter]: 1}));
          }
          else if (panel ==="projects"){
            dispatcher(setProjectsSortFilter({[filter]: 1}));
          }
          else if (panel ==="LeadDistributor"){
            dispatcher(setLeadDistributionSortFilter({[filter]: 1}));
          }
          else{
            dispatcher(setFilterSort({ [filter]: 1 }));
          }
        } else if (savedSort === '2') {
          if(DrillDownpanel === "call logs drilldown"){
            dispatcher(setCallLogDrillDownFilterSort({ [filter]: -1 }));
          }
          else if(DrillDownpanel === "contacts drilldown"){
            dispatcher(setContactDrillDownFilterSort({ [filter]: -1 }));
          }
          else if(DrillDownpanel === "tasks drilldown"){
            dispatcher(setTaskDrillDownFilterSort({ [filter]: -1 }));
          }
          else if(panel === "User" || panel ==="contacts" ){
            dispatcher(setUserFilterSort({ [filter]: -1 }));
          }
          else if(panel==="DeletedLogs"){
            dispatcher(setDeleteLogsSortFilter({ [filter]: -1 }));
          }
          else if(panel === "Task"){
            dispatcher(setTaskFilterSort({ [filter]: -1 }));
          }
          else if(panel === "CallLogs"){
            dispatcher(setCallLogFilterSort({ [filter]: -1 }));
          }
          // else if(panel === "Reenquired"){
          //   dispatcher(setReenquiredFilterSort({ [filter]: -1 }));
          // }
          else if (panel ==="API"){
            dispatcher(setAPITokensSortFilter({[filter]: -1}));
          }
          else if (panel ==="API Leads"){
            dispatcher(setAPIDataSortFilter({[filter]: -1}));
          }
          else if (panel ==="projects"){
            dispatcher(setProjectsSortFilter({[filter]: -1}));
          }
          else if (panel ==="LeadDistributor"){
            dispatcher(setLeadDistributionSortFilter({[filter]: -1}));
          }
          else{
            dispatcher(setFilterSort({ [filter]: -1 }));
          }
        } else {
          setSort(0);
        }
      }, 100);
    } else {
      setTimeout(() => {
        setSort(0);
      }, 100);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const savedSort = localStorage.getItem(filterId + 'sort');
    if (column.isSorted === false && savedSort === null) setSort(0);
    // eslint-disable-next-line
  }, [column.isSorted]);

  useEffect(() => {
    if (filterObject[column.id]) {
      setFilterItems(filterObject[column.id]);
    }
  }, [column.id, filterObject]);

  useEffect(() => {
    if (searchedItem.length === 0) {
      setFilterItems(filterObject[column.id]);
    }
    else {
      let data;
      if((filterItems && column.id !== "employee_id" && column.id !== "employee_name")){
        if (typeof filterItems[0] === 'string') {
          data = filterObject[column.id].filter((item) =>
            item && item.toLowerCase().includes(searchedItem.toLowerCase())
          );
        }
        else {
          data = filterObject[column.id].filter((item) =>
            item && item.toString().includes(searchedItem.toString()) || item && item.toLowerCase().includes(searchedItem.toLowerCase())
          );
        }
        setFilterItems(data);
      }
      if((filterItems && (column.id == "employee_id" || column.id == "employee_name"))){
        data = filterObject[column.id].filter((item:any) =>
        item && item.label.toLowerCase().includes(searchedItem.toLowerCase())
      );
        setFilterItems(data);
      }
    }
    // eslint-disable-next-line
  }, [searchedItem]);

  const handleClickOutside = useCallback((event: any) => {
    const element: any = filterRef.current;
    if (element && !element.contains(event.target)) {
      hide();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (expand === true) {
      setTimeout(
        () => document.addEventListener('click', handleClickOutside),
        100
      );
    } else {
      document.removeEventListener('click', handleClickOutside);
    }

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
    // eslint-disable-next-line
  }, [expand]);

  const filterClass = classNames(styles.parent, {
    [styles.showFilterAnim]: expand === true,
  });
  const [currentLimit, setCurrentLimit] = useState(5);

  const setDateFilter = (date: Date | null, type: 'from' | 'to') => {
    if (date === null) {
      return;
    }
    let tempDateArray = [...dateArray];
    if (type === 'from') {
      const newDate = moment(date).startOf('day').toDate();
      tempDateArray[0] = newDate;
    } else {
      const newDate = moment(date).endOf('day').toDate();
      tempDateArray[1] = newDate;
    }

    setDateArray(tempDateArray);
    if (tempDateArray[0] && tempDateArray[1]) {
      if(DrillDownpanel === "call logs drilldown"){
        dispatcher(setCallLogDrillDownFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}));
      }
      else if(DrillDownpanel === "contacts drilldown"){
        dispatcher(setContactDrillDownFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}));
      }
      else if(DrillDownpanel === "tasks drilldown"){
        dispatcher(setTaskDrillDownFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}));
      }
      else if(panel === "Reenquired"){
        dispatcher(setReenquiredFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}));
      }
      else if(panel === "User" || panel ==="contacts" ){
        dispatcher(setUserFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}));
      }
      else if(panel==="DeletedLogs"){
        dispatcher(setDeleteLogsFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}));
      }
      else if(panel === "Task"){
        dispatcher(setTaskFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}));
      }
      else if(panel === "CallLogs"){
        dispatcher(setCallLogFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}));
      }
      else if (panel ==="API"){
        dispatcher(setAPITokensFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}))
      }
      else if (panel ==="projects"){
        dispatcher(setProjectsFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}))
      }
      else if (panel ==="API Leads"){
        dispatcher(setAPIDataFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}))
      }
      else if (panel ==="LeadDistributor"){
        dispatcher(setLeadDistributionFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}))
      }
      else{
        dispatcher(setFilter({[filter]: [ tempDateArray[0].toISOString(), tempDateArray[1].toISOString(),],}));
      }
      localStorage.setItem(filterId, JSON.stringify(tempDateArray));
    }
  };
const containerStyles = { backgroundColor:theme ? themeColors.dropdownBackgroundColor:themeColors.dropdownBackgroundColorDark,color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}
const checkboxStyles = {color:theme ? themeColors.textPrimary:themeColors.textPrimaryDark}  
return (
    <div className={filterClass} ref={filterRef} style={containerStyles}>
      <div
        className={styles.child}
        onClick={() => {
          setSort(1);
          hide();
          localStorage.setItem(filterId + 'sort', '1');
          if(DrillDownpanel === "call logs drilldown"){
            dispatcher(setCallLogDrillDownFilterSort({ [filter]: 1 }));
          }
          else if(DrillDownpanel === "contacts drilldown"){
            dispatcher(setContactDrillDownFilterSort({ [filter]: 1 }));
          }
          else if(DrillDownpanel === "tasks drilldown"){
            dispatcher(setTaskDrillDownFilterSort({ [filter]: 1 }));
          }
          else if(panel === "User" || panel ==="contacts" ){
            dispatcher(setUserFilterSort({ [filter]: 1 }));
          }
          else if(panel==="DeletedLogs"){
            dispatcher(setDeleteLogsSortFilter({ [filter]: 1 }));
          }
          else if(panel === "Task"){
            dispatcher(setTaskFilterSort({ [filter]: 1 }));
          }
          else if(panel === "CallLogs"){
            dispatcher(setCallLogFilterSort({ [filter]: 1 }));
          }
          // else if(panel === "Reenquired"){
          //   dispatcher(setReenquiredFilterSort({ [filter]: 1 }));
          // }
          else if (panel ==="API"){
            dispatcher(setAPITokensSortFilter({[filter]: 1}));
          }
          else if (panel ==="API Leads"){
            dispatcher(setAPIDataSortFilter({[filter]: 1}));
          }
          else if (panel ==="projects"){
            dispatcher(setProjectsSortFilter({[filter]: 1}));
          }
          else if (panel ==="LeadDistributor"){
            dispatcher(setLeadDistributionSortFilter({[filter]: 1}));
          }
          else{
            dispatcher(setFilterSort({ [filter]: 1 }));
          }
        }}
        style={containerStyles}
      >
        <AiOutlineArrowUp color={sort === 1 ? '#279ea0' : '#000'} size={20} />
        <p 
        className={styles.text}
        >
          {column.Header === 'Lead Assign Date & Time'
            ? 'Oldest to latest'
            : column.Header === 'Created Date & Time'
              ? 'Oldest to latest'
              : column.Header === 'Created On'
              ? 'Oldest to latest'
              : column.Header === 'Modified On'
              ? 'Oldest to latest'
              : column.Header === 'Stage Change Date & Time'
              ? 'Oldest to latest'
              : column.Header === 'Modified Date & Time'
              ? 'Oldest to latest'
              : column.Header === 'Call Response Time'
              ? 'Oldest to latest'
              : column.Header === 'Next Follow Up Date & Time'
              ? 'Oldest to latest'
              : column.Header === 'Lead Assigned On'
              ? 'Oldest to latest'
              : column.Header === 'Next Follow Up On'
              ? 'Oldest to latest'
              : column.Header === 'Stage Changed On'
              ? 'Oldest to latest'
              : column.Header === 'Lead Stage Changed On'
              ? 'Oldest to latest'
              : column.Header === 'Due On'
              ? 'Oldest to latest'
              : column.Header === 'Completed On'
              ? 'Oldest to latest'
              : 'Sort A to Z'}
        </p>
      </div>
      <div
        className={styles.child}
        onClick={() => {
          setSort(2);
          hide();
          localStorage.setItem(filterId + 'sort', '2');
          if(DrillDownpanel === "call logs drilldown"){
            dispatcher(setCallLogDrillDownFilterSort({ [filter]: -1 }));
          }
          else if(DrillDownpanel === "contacts drilldown"){
            dispatcher(setContactDrillDownFilterSort({ [filter]: -1 }));
          }
          else if(DrillDownpanel === "tasks drilldown"){
            dispatcher(setTaskDrillDownFilterSort({ [filter]: -1 }));
          }
          else if(panel === "User" || panel ==="contacts" ){
            dispatcher(setUserFilterSort({ [filter]: -1 }));
          }
          else if( panel==="DeletedLogs"){
            dispatcher(setDeleteLogsSortFilter({ [filter]: -1 }));
          }
          else if(panel === "Task"){
            dispatcher(setTaskFilterSort({ [filter]: -1 }));
          }
          else if(panel === "CallLogs"){
            dispatcher(setCallLogFilterSort({ [filter]: -1 }));
          }
          // else if(panel === "Reenquired"){
          //   dispatcher(setReenquiredFilterSort({ [filter]: -1 }));
          // }
          else if (panel ==="API"){
            dispatcher(setAPITokensSortFilter({[filter]: -1}));
          }
          else if (panel ==="API Leads"){
            dispatcher(setAPIDataSortFilter({[filter]: -1}));
          }
          else if (panel ==="projects"){
            dispatcher(setProjectsSortFilter({[filter]: -1}));
          }
          else if (panel ==="LeadDistributor"){
            dispatcher(setLeadDistributionSortFilter({[filter]: -1}));
          }
          else{
            dispatcher(setFilterSort({ [filter]: -1 }));
          }
        }}
      >
        <AiOutlineArrowDown color={sort === 2 ? '#279ea0' : '#000'} size={20} />
        <p className={styles.text}>
          {column.Header === 'Lead Assign Date & Time'
            ? 'Latest to Oldest'
            : column.Header === 'Created Date & Time'
              ? 'Latest to Oldest'
            : column.Header === 'Created On'
              ? 'Latest to Oldest'
              : column.Header === 'Stage Change Date & Time'
              ? 'Latest to Oldest'
              : column.Header === 'Modified On'
              ? 'Latest to Oldest'
              : column.Header === 'Modified Date & Time'
              ? 'Latest to Oldest'
              : column.Header === 'Call Response Time'
              ? 'Latest to Oldest'
              : column.Header === 'Next Follow Up Date & Time'
              ? 'Latest to Oldest'
              : column.Header === 'Lead Assigned On'
              ? 'Latest to Oldest'
              : column.Header === 'Next Follow Up On'
              ? 'Latest to Oldest'
              : column.Header === 'Stage Changed On'
              ? 'Latest to Oldest'
              : column.Header === 'Lead Stage Changed On'
              ? 'Latest to Oldest'
              : column.Header === 'Due On'
              ? 'Latest to Oldest'
              : column.Header === 'Completed On'
              ? 'Latest to Oldest'
              : 'Sort Z to A'
              }
        </p>
      </div>
      <div className={styles.line} />
      {dateFieldList.includes(column.Header) ? (
        <div className={styles.dateInputContainer}>
          <p
            className={styles.optionText}
            style={{ marginTop: '5px', marginBottom: '4px' }}
          >
            From:
          </p>
          <input
            className={styles.dateInput}
            type="date"
            id="from"
            name="from"
            value={
              dateArray[0] ? moment(dateArray[0]).format('YYYY-MM-DD') : ''
            }
            onChange={(e) => {
              setDateFilter(e.target.valueAsDate, 'from');
            }}
          />
          <p
            className={styles.optionText}
            style={{ marginTop: '12px', marginBottom: '4px' }}
          >
            To:
          </p>
          <input
            type="date"
            id="to"
            name="to"
            className={styles.dateInput}
            value={
              dateArray[1] ? moment(dateArray[1]).format('YYYY-MM-DD') : ''
            }
            onChange={(e) => {
              setDateFilter(e.target.valueAsDate, 'to');
            }}
          />
        </div>
      ) : (
        <>
          {!noFilter.includes(column.id) && (
            <>
              <div className={styles.searchBox}>
                <input
                  className={styles.searchText}
                  placeholder={'Search'}
                  onChange={(val) => setsearchedItem(val.target.value)}
                  value={searchedItem}
                  ref={inputRef}
                />
                {searchedItem.length === 0 ? (
                  <AiOutlineSearch color={'#279ea0'} size={15} />
                ) : (
                  <AiOutlineClose
                    color={'#ff0000'}
                    size={15}
                    onClick={() => setsearchedItem('')}
                  />
                )}
              </div>
              <div className={styles.resultBox}>
                <InfiniteScroll
                  height={180}
                  dataLength={currentLimit}
                  next={() => setCurrentLimit(currentLimit + 5)}
                  hasMore={filterItems?.length > currentLimit}
                  loader={<p>Loading...</p>}
                  className={styles.infiniteScroll}
                >
                  <>
                  {
                    (filterItems && column.id !== "employee_id" && column.id !== "employee_name" && column.id !=="listing_created_by"
                  ) && (
                      <div className={styles.checkView}>
                      <Checkbox
                      style={checkboxStyles}
                        size="small"
                        onChange={(e) => {
                          let data: any[] = [...filterItems];
                          if (e.target.checked) {
                            data = [...filterItems];
                            setFilterRow(data);
                            localStorage.setItem(
                              filterId,
                              JSON.stringify(data)
                            );
                          } else if (!e.target.checked) {
                            data = [];
                            setFilterRow(data);
                            localStorage.setItem(
                              filterId,
                              JSON.stringify(data)
                            );
                          }
                          if(DrillDownpanel === "call logs drilldown"){
                            dispatcher(setCallLogDrillDownFilter({ [filter]: data }));
                          }
                          else if(DrillDownpanel === "contacts drilldown"){
                            dispatcher(setContactDrillDownFilter({ [filter]: data }));
                          }
                          else if(DrillDownpanel === "tasks drilldown"){
                            dispatcher(setTaskDrillDownFilter({ [filter]: data }));
                          }
                          else if(panel === "Reenquired"){
                            dispatcher(setReenquiredFilter({ [filter]: data }));
                          }
                          else if(panel === "User" ){
                            dispatcher(setUserFilter({ [filter]: data }));
                          }
                          else if( panel==="DeletedLogs"){
                            dispatcher(setDeleteLogsFilter({ [filter]: data }));
                          }
                          else if(panel === "Task"){
                            dispatcher(setTaskFilter({ [filter]: data }));
                          }
                          else if(panel === "CallLogs"){
                            dispatcher(setCallLogFilter({ [filter]: data }));
                          }
                          else if (panel ==="API"){
                            dispatcher(setAPITokensFilter({ [filter]: data }))
                          }
                          else if (panel ==="projects"){
                            dispatcher(setProjectsFilter({ [filter]: data }))
                          }
                          else if (panel ==="API Leads"){
                            dispatcher(setAPIDataFilter({ [filter]: data }))
                          }
                          else if (panel ==="LeadDistributor"){
                            dispatcher(setLeadDistributionFilter({ [filter]: data }))
                          }
                          else{
                            dispatcher(setFilter({ [filter]: data }));
                          }
                          
                        }}
                        checked={
                          filterRow &&
                          filterItems &&
                          filterRow?.length === filterItems.length &&
                          filterItems.length>0?true:false
                        }
                      />
                      <p className={styles.optionText}>SELECT ALL</p>
                    </div>
                    )
                  }
                   {
                    (filterItems && (column.id === "employee_id" || column.id === "employee_name" 
                    || column.id ==="listing_created_by"
                  )) && (
                      <div className={styles.checkView}>
                     
                      <Checkbox
                      style={checkboxStyles}
                        size="small"
                        onChange={(e) => {
                          console.log("wqwqwq",filterItems)
                          let values = filterItems.map((item:any) => {
                            // console.log("filterObjectrishabh",item.value)
                            return item.value
                          })
                          let data: any[] = [...values];
                          if (e.target.checked) {
                            data = [...values];
                            setFilterRow(data);
                            localStorage.setItem(
                              filterId,
                              JSON.stringify(data)
                            );
                          } else if (!e.target.checked) {
                            data = [];
                            setFilterRow(data);
                            localStorage.setItem(
                              filterId,
                              JSON.stringify(data)
                            );
                          }
                          if(DrillDownpanel === "call logs drilldown"){
                            dispatcher(setCallLogDrillDownFilter({ [filter]: data }));
                          }
                          else if(DrillDownpanel === "contacts drilldown"){
                            dispatcher(setContactDrillDownFilter({ [filter]: data }));
                          }
                          else if(DrillDownpanel === "tasks drilldown"){
                            dispatcher(setTaskDrillDownFilter({ [filter]: data }));
                          }
                          else if(panel === "Reenquired"){
                            dispatcher(setReenquiredFilter({ [filter]: data }));
                          }
                          else if(panel === "User"){
                            dispatcher(setUserFilter({ [filter]: data }));
                          }
                          else if( panel==="DeletedLogs"){
                            dispatcher(setDeleteLogsFilter({ [filter]: data }));
                          }
                          else if(panel === "Task"){
                            dispatcher(setTaskFilter({ [filter]: data }));
                          }
                          else if(panel === "CallLogs"){
                            dispatcher(setCallLogFilter({ [filter]: data }));
                          }
                          else if (panel ==="API"){
                            dispatcher(setAPITokensFilter({ [filter]: data }))
                          }
                          else if (panel ==="projects"){
                            dispatcher(setProjectsFilter({ [filter]: data }))
                          }
                          else if (panel ==="API Leads"){
                            dispatcher(setAPIDataFilter({ [filter]: data }))
                          }
                          else if (panel ==="LeadDistributor"){
                            dispatcher(setLeadDistributionFilter({ [filter]: data }))
                          }
                          else{
                            dispatcher(setFilter({ [filter]: data }));
                          }
                          
                        }}
                        checked={
                          filterRow &&
                          filterItems &&
                          filterRow?.length === filterItems.length &&
                          filterItems.length>0?true:false
                        }
                      />
                      <p className={styles.optionText}>SELECT ALL</p>
                    </div>
                    )
                  }
                    {(filterItems && column.id !== "employee_id" && column.id !== "employee_name"  
                   && column.id !=="listing_created_by"
                  ) &&
                      filterItems.slice(0, currentLimit).sort().map((item, index) => (
                        <div key={index} className={styles.checkView}>
                          <Checkbox
                            style={checkboxStyles}
                            size="small"
                            onChange={(e) => {
                              const data = [...filterRow];
                              if (e.target.checked) {
                                data.push(item);
                                setFilterRow(data);
                              } else if (!e.target.checked) {
                                const val = data.indexOf(item);
                                if (val > -1) {
                                  data.splice(val, 1);
                                }
                                setFilterRow(data);
                              }

                              localStorage.setItem(
                                filterId,
                                JSON.stringify(data)
                              );
                              if(DrillDownpanel === "call logs drilldown"){
                                dispatcher(setCallLogDrillDownFilter({ [filter]: data }));
                              }
                              else if(DrillDownpanel === "contacts drilldown"){
                                dispatcher(setContactDrillDownFilter({ [filter]: data }));
                              }
                              else if(DrillDownpanel === "tasks drilldown"){
                                dispatcher(setTaskDrillDownFilter({ [filter]: data }));
                              }
                              if(panel === "Reenquired"){
                                dispatcher(setReenquiredFilter({ [filter]: data }));
                              }
                              if(panel === "User" ){
                                dispatcher(setUserFilter({ [filter]: data }));
                              }
                              if(panel==="DeletedLogs"){
                                dispatcher(setDeleteLogsFilter({ [filter]: data }));
                              }
                              else if(panel === "Task"){
                                dispatcher(setTaskFilter({ [filter]: data }));
                              }
                              else if(panel === "CallLogs"){
                                dispatcher(setCallLogFilter({ [filter]: data }));
                              }
                              else if (panel ==="API"){
                                dispatcher(setAPITokensFilter({ [filter]: data }))
                              }
                              else if (panel ==="projects"){
                                dispatcher(setProjectsFilter({ [filter]: data }))
                              }
                              else if (panel ==="API Leads"){
                                dispatcher(setAPIDataFilter({ [filter]: data }))
                              }
                              else if (panel ==="LeadDistributor"){
                                dispatcher(setLeadDistributionFilter({ [filter]: data }))
                              }
                              else{
                                dispatcher(setFilter({ [filter]: data }));
                              }
                            }}
                            checked={filterRow.includes(item)}
                          />
                          <p className={styles.optionText}>{column.id=== "budget"?formatLeadBudget(item):item}</p>
                        </div>
                      ))}                
                        {(filterItems && (column.id == "employee_id" || column.id == "employee_name" 
                       || column.id =="listing_created_by"
                      )) &&
                      filterItems.slice(0, currentLimit).sort(option).map((item:any, index:any) => (
                        <div key={index} className={styles.checkView}>
                          <Checkbox
                            style={checkboxStyles}
                            size="small"
                            onChange={(e) => {
                              console.log("ededed",filterRow)
                              const data = [...filterRow];
                              if (e.target.checked) {
                                data.push(item.value);
                                setFilterRow(data);
                              } else if (!e.target.checked) {
                                const val = data.indexOf(item.value);
                                if (val > -1) {
                                  data.splice(val, 1);
                                }
                                setFilterRow(data);
                              }

                              localStorage.setItem(
                                filterId,
                                JSON.stringify(data)
                              );
                              if(DrillDownpanel === "call logs drilldown"){
                                dispatcher(setCallLogDrillDownFilter({ [filter]: data }));
                              }
                              else if(DrillDownpanel === "contacts drilldown"){
                                dispatcher(setContactDrillDownFilter({ [filter]: data }));
                              }
                              else if(DrillDownpanel === "tasks drilldown"){
                                dispatcher(setTaskDrillDownFilter({ [filter]: data }));
                              }
                              if(panel === "Reenquired"){
                                dispatcher(setReenquiredFilter({ [filter]: data }));
                              }
                              if(panel === "User" ){
                                dispatcher(setUserFilter({ [filter]: data }));
                              }
                              if( panel==="DeletedLogs"){
                                dispatcher(setDeleteLogsFilter({ [filter]: data }));
                              }
                              else if(panel === "Task"){
                                dispatcher(setTaskFilter({ [filter]: data }));
                              }
                              else if(panel === "CallLogs"){
                                dispatcher(setCallLogFilter({ [filter]: data }));
                              }
                              else if (panel ==="API"){
                                dispatcher(setAPITokensFilter({ [filter]: data }))
                              }
                              else if (panel ==="projects"){
                                dispatcher(setProjectsFilter({ [filter]: data }))
                              }
                              else if (panel ==="API Leads"){
                                dispatcher(setAPIDataFilter({ [filter]: data }))
                              }
                              else if (panel ==="LeadDistributor"){
                                dispatcher(setLeadDistributionFilter({ [filter]: data }))
                              }
                              else{
                                dispatcher(setFilter({ [filter]: data }));
                              }
                            }}
                            checked={filterRow.includes(item.value)}
                          />
                          <p className={styles.optionText}>{item.label}</p>
                        </div>
                      ))}
                  </>
                </InfiniteScroll>
              </div>
            </>
          )}
        </>
      )}
      <div className={styles.buttonBox}>
        <button className={styles.clearButton} onClick={clearFilter}>
          Clear Filter
        </button>
        <button className={styles.applyButton} onClick={close}>
          Close
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    filterObject: state.filterObject,
    globalClearFilter: state.clearFilter.clear,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(ApiFilterModal);
